// mypreset.ts
import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
// import Nora from '@primeng/themes/nora';
// import Lara from '@primeng/themes/lara';
// import Material from '@primeng/themes/material';

const MyPreset = definePreset(Aura, {
    // const MyPreset = definePreset(Nora, {
    // const MyPreset = definePreset(Lara, {
    // const MyPreset = definePreset(Material, {
    primitive: {
        blue: palette('#317ffe'),
        green: palette('#558B2F'),
        yellow: palette('#FFA726'),
        purple: palette('#7E57C2'),
        red: palette('#E53935'),
        grey: palette('#6B7280')
    },
    semantic: {
        errorColor: '{red.500}',
        focusRing: '0 0 0 0.2rem rgba(59, 130, 246, 0.25)',
        highlightTextColor: '{primary.500}',
        listHeaderBg: 'rgba(189,189,189,0.075)',
        groupHeaderBg: 'rgba(189,189,189,0.1)',
        disabledOpacity: '0.7',
        border: {
            radius: {
                xs: '.125rem',
                sm: '.25rem',
                md: '.3333rem',
                lg: '.5rem',
                xl: '.6667rem'
            }
        },
        colorScheme: {
            light: {
                primary: {
                    ...palette('#92bbff'),
                    color: '#0161fe',
                    colorDarker: '#083BA6',
                    colorText: '#FFFDFA',
                    inverseColor: '#061856',
                    hoverColor: '{primary.color.darker}',
                    activeColor: '#061856'
                },
                surface: {
                    0: '#ffffff',
                    50: '#FAFAFA',
                    100: '#F5F5F5',
                    200: '#EEEEEE',
                    300: '#E0E0E0',
                    400: '#BDBDBD',
                    500: '#9E9E9E',
                    600: '#757575',
                    700: '#616161',
                    800: '#424242',
                    900: '#212121',
                    950: '#000000'
                },
                logoColor: {
                    1: '{primary.color}',
                    2: '{primary.color.darker}'
                },
                textColor: '#1C232C',
                textColorSecondary: '{surface.600}',
                surfaceGround: '{surface.200}',
                surfaceSection: '{surface.50}',
                surfaceCard: '{surface.0}',
                surfaceOverlay: '{surface.0}',
                surfaceBorder: '{surface.300}',
                surfaceBorderDarker: '{surface.400}',
                surfaceHover: '{surface.100}',
                formFieldBackground: '{surfaceGround}',
                highlight: {
                    background: '{primary.100}',
                    color: '{colorText}',
                    focus: {
                        background: '{primary.200}'
                    }
                },
                shadow: {
                    0: '0px 0px 8px 0px rgba(0, 0, 0, 0.3)',
                    3: '0 0 14px 0 rgba(0, 0, 0, 0.6)'
                }
            },
            dark: {
                primary: {
                    ...palette('#7daefe'),
                    color: '#317ffe',
                    colorDarker: '#083BA6',
                    colorText: '#FFFDFA',
                    inverseColor: '#061856',
                    hoverColor: '{primary.color.darker}',
                    activeColor: '#061856',
                    contrastColor: '{primary.colorText}'
                },
                surface: {
                    0: '#f2f1f1',
                    50: '#dcdada',
                    100: '#c6c4c4',
                    200: '#b0afaf',
                    300: '#9b9a9a',
                    400: '#868585',
                    500: '#727171',
                    600: '#5f5e5e',
                    700: '#4c4b4b',
                    800: '#3a3939',
                    900: '#292828',
                    950: '#191818'
                },
                logoColor: {
                    1: '{primary.color}',
                    2: '#F6F4F1'
                },
                textColor: '#FFFDFA',
                textColorSecondary: '{surface.200}',
                surfaceGround: '{surface.950}',
                surfaceSection: '{surface.800}',
                surfaceCard: '{surface.900}',
                surfaceOverlay: '{surface.900}',
                surfaceBorder: '{surface.700}',
                surfaceBorderDarker: '{surface.600}',
                surfaceHover: '{surface.700}',
                formFieldBackground: '{surfaceGround}',
                highlight: {
                    background: '{primary.900}',
                    color: '{colorText}',
                    focus: {
                        background: '{primary.800}'
                    }
                },
                shadow: {
                    0: '0px 0px 8px 0px rgba(0, 0, 0, 1)',
                    3: '0 0 14px 0 rgba(0, 0, 0, 1)'
                }
            }
        }
    },
    components: {
        listbox: {
            background: '{surface.card}',
            css: ({ dt }: { dt: (path: string) => string }) => `
                .p-listbox-header  {
                    background-color: ${dt('list.header.bg')};
                }
                .p-listbox-option-group {
                    background-color: ${dt('group.header.bg')};
                    color: var(--p-text-color);
                }
              `
        },
        tree: {
            nodePadding: '.25rem .375rem', // '0.125rem 0rem',
            gap: '0',
            indent: '12px',
            css: ({ dt }: { dt: (path: string) => string }) => `
                .p-tree-header, .p-iconfield {
                    background-color: ${dt('list.header.bg')} !important;
                }
              `
        },
        checkbox: {
            icon: {
                size: '14px'
            }
        },
        toolbar: {
            padding: '0'
        },
        card: {
            title: {
                font: {
                    size: '1.3333rem',
                    weight: '400'
                }
            }
        },
        tabs: {
            tabHoverBackground: 'var(--p-highlight-background)',
            tabHoverBorderColor: 'var(--p-highlight-focus-background)'
        },
        toggleswitch: {
            // background: 'var(--p-surface-ground) !important'
        },
        tooltip: {
            maxWidth: 'max-content'
        },
        input: {
            padding: '2px'
        },
        toast: {
            success: {
                background: 'var(--p-green-500) !important',
                borderColor: 'var(--p-green-500) !important',
                color: 'var(--p-primary-color-text) !important',
                detailColor: 'var(--p-primary-color-text) !important'
            },
            warn: {
                background: 'var(--p-yellow-500) !important',
                borderColor: 'var(--p-yellow-500) !important',
                color: 'var(--p-primary-color-text) !important',
                detailColor: 'var(--p-primary-color-text) !important'
            },
            error: {
                background: 'var(--p-red-500) !important',
                borderColor: 'var(--p-red-500) !important',
                color: 'var(--p-primary-color-text) !important',
                detailColor: 'var(--p-primary-color-text) !important'
            },
            info: {
                background: 'var(--p-primary-color) !important',
                borderColor: 'var(--p-primary-color) !important',
                color: 'var(--p-primary-color-text) !important',
                detailColor: 'var(--p-primary-color-text) !important'
            }
        }
    }
});

export default MyPreset;
